import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nirali-kartik',
  templateUrl: './nirali-kartik.component.html',
  styleUrls: ['./nirali-kartik.component.scss']
})
export class NiraliKartikComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
